import React, { Component as C } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

import styles from "./index.less"

export default class extends C {
  static propTypes = {
    className: PropTypes.string,
  }

  render() {
    let paperClassName = classnames(styles.paper, this.props.className)

    return (
      <div style={this.props.style} className={paperClassName} ref={this.props.setRef}>
        {this.props.children}
      </div>
    )
  }
}
